<template>
    <div
            class="rounded-lg bg-slate-blue-900"
            :class="{ 'shadow-panel-shadow': !flat }"
    >
        <slot/>
    </div>
</template>

<script>
export default {
  name: 'Panel',
  props: {
    flat: Boolean
  }
}
</script>

<style scoped>

</style>
